import { RootRoutes } from '../../../constants';

export const AnalyticsRoutes = {
	Root: `${RootRoutes.Analytics}/public`,
};
